module.exports = __webpack_public_path__ + "static/fonts/iconfont.aee4a273.woff";